const nav = document.querySelector('.navbar'); // or your nav selector

    function checkScroll() {
        if (window.scrollY > 0) {
            nav.classList.add("scrolled");
        } else {
            nav.classList.remove("scrolled");
        }
    }

    // Run on page load
    document.addEventListener("DOMContentLoaded", checkScroll);

    // Run on scroll
    window.addEventListener("scroll", checkScroll);

    document.addEventListener("DOMContentLoaded", function() {
        const navToggler = document.querySelector(".navbar-toggler");
        const nav = document.querySelector(".navbar");
        const header = document.querySelector(".site-header-trans");
        const header2 = document.querySelector(".site-header");

        // Toggle the 'active' class on the nav element
        navToggler.addEventListener("click", function() {
            nav.classList.toggle("active");
        });
    });

    document.addEventListener("DOMContentLoaded", function() {
        let clicked = false;
        let hasBoundClick = false;
        let previousWidth = window.innerWidth;

        const navbarToggler = document.querySelector('.navbar-toggler');
        const navItems = document.querySelectorAll('.navbar-nav .menu-item');
        const navbarMenu = document.querySelector('.navbar .navbar-collapse');
        const mobileNavLogo = document.querySelector('.navbar-brand .d-lg-none');
        const mobileHamburger = document.querySelector('.navbar-toggler-icon');
        const mobileClose = document.querySelector('.navbar-toggler-close');
        const nav = document.querySelector(".navbar");
        const socials = document.querySelector('.mobile-socials');

        function setInitialMobileNavState() {
            anime.set(navItems, {
                opacity: 0
            });
            anime.set(navbarMenu, {
                translateX: '200%',
                translateY: '-100%',
                scale: 0,
                borderRadius: '100%',
            });
            anime.set([mobileNavLogo, mobileHamburger], {
                filter: 'contrast(1) brightness(1)',
                rotate: 0,
                opacity: 1
            });
            anime.set(mobileClose, {
                opacity: 0,
                rotate: 0
            });
            anime.set(socials, {
                opacity: 0,
            })

            // Also make sure classes are reset
            navbarMenu.classList.remove('show');
        }

        function openMobileNav() {
            clicked = true;
            navbarMenu.classList.add('show');
            anime({
                targets: mobileNavLogo,
                filter: ['contrast(1) brightness(1)', 'contrast(0) brightness(2)'],
                duration: 700,
                delay: 200,
                easing: 'easeInOutSine'
            });
            anime({
                targets: mobileHamburger,
                filter: ['contrast(1) brightness(1)', 'contrast(0) brightness(2)'],
                rotate: 360,
                opacity: 0,
                duration: 500,
                delay: 300,
                easing: 'easeInOutSine'
            });
            anime({
                targets: mobileClose,
                opacity: 1,
                rotate: 360,
                duration: 500,
                delay: 300,
                easing: 'easeInOutSine'
            });
            anime({
                targets: navbarMenu,
                scale: [0, 1],
                translateX: 0,
                translateY: 0,
                borderRadius: 0,
                duration: 1000,
                easing: 'easeInOutSine'
            });
            anime({
                targets: navItems,
                opacity: 1,
                delay: 1100,
                duration: 700,
                easing: 'easeInOutSine'
            });
            anime({
                targets: socials,
                opacity: 1,
                delay: 1100,
                duration: 700,
                easing: 'easeInOutSine'
            });
        }

        function closeMobileNav() {
            clicked = false;
            anime({
                targets: mobileNavLogo,
                filter: ['contrast(0) brightness(2)', 'contrast(1) brightness(1)'],
                duration: 700,
                delay: 600,
                easing: 'easeInOutSine'
            });
            anime({
                targets: mobileHamburger,
                filter: ['contrast(0) brightness(2)', 'contrast(1) brightness(1)'],
                rotate: 0,
                opacity: 1,
                duration: 500,
                delay: 700,
                easing: 'easeInOutSine'
            });
            anime({
                targets: mobileClose,
                opacity: 0,
                rotate: 0,
                duration: 500,
                delay: 700,
                easing: 'easeInOutSine'
            });
            anime({
                targets: navbarMenu,
                translateX: '200%',
                translateY: '-100%',
                scale: [1, 0],
                borderRadius: '100%',
                duration: 1000,
                delay: 700,
                easing: 'easeInOutSine',
                complete: function() {
                    navbarMenu.classList.remove('show');
                }
            });
            anime({
                targets: navItems,
                opacity: 0,
                duration: 700,
                easing: 'easeInOutSine'
            });
            anime({
                targets: socials,
                opacity: 0,
                duration: 700,
                easing: 'easeInOutSine'
            });
        }

        function init() {
            const isMobile = window.innerWidth < 992;

            if (isMobile) {
                setInitialMobileNavState();
                if (!hasBoundClick) {
                    navbarToggler.addEventListener('click', function() {
                        clicked ? closeMobileNav() : openMobileNav();
                    });
                    hasBoundClick = true;
                }
            } else {
                // Reset when switching to desktop view
                clicked = false;
                navbarMenu.classList.remove('show');
                anime.set(navItems, {
                    translateX: 0,
                    opacity: 1
                });
                anime.set(navbarMenu, {
                    translateX: 0,
                    translateY: 0,
                    scale: 1,
                    borderRadius: 0
                });
            }
        }

        window.addEventListener('resize', function() {
            const currentWidth = window.innerWidth;
            const crossedToMobile = previousWidth >= 992 && currentWidth < 992;
            const crossedToDesktop = previousWidth < 992 && currentWidth >= 992;

            if (crossedToMobile || crossedToDesktop) {
                clicked = false; // Reset state when breakpoint is crossed
            }

            previousWidth = currentWidth;
            init(); // re-run the layout/animation reset
        });

        init();
    });